module.exports = __webpack_public_path__ + "static/media/loading-img.3dd3ce3c.png";